import { SubscriptionState } from "./backend/Clients";

const subscriptionStateColorMap: Record<SubscriptionState, string> = {
  "1": 'default',
  "2": 'processing',
  "3": 'warning',
  "4": 'error',
}

export default subscriptionStateColorMap;